import React, {useState, useEffect} from 'react';
import {toast} from 'react-toastify';
import axios from 'axios';
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Pagination from 'react-bootstrap/Pagination';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import { useRef } from 'react';
import carrito from '../imgs/carrito.png';
import '../css/styles.css';

import { useLocation } from 'react-router-dom'

// Ahora devuelve 'nuevo' cuando promedio === 0
const calcularColor = (metrica3, metrica) => {
  const promedio  = parseFloat(metrica3) || 0;
  const facturado = parseFloat(metrica)  || 0;
  if (promedio > 0) {
    const pct = (facturado / promedio) * 100;
    if (pct <= 20)  return 'rojo';
    if (pct <= 75)  return 'amarillo';
    return 'verde';
  }
  return 'nuevo'; // antes era 'verde', ahora es categoría propia sin color
};

const COLOR_HEX = {
  rojo:     '#ef4444',
  amarillo: '#eab308',
  verde:    '#22c55e',
  // 'nuevo' no tiene color de barra
};

// fontSize 15px (antes 14px); bold; sin border inferior; fondo se aplica por fila
const CELL = {
  fontSize:      '15px',
  fontWeight:    'bold',
  borderBottom:  'none',
  verticalAlign: 'middle',
  padding:       '5px 6px',
  wordBreak:     'break-word',
  whiteSpace:    'normal',
};

const TabContent = ({cli}) => {
  const [currentPage, setCurrentPage]             = useState(1);
  const [itemsPerPage, setItemsPerPage]            = useState(10);
  const [data, setData]                            = useState([]);
  const [modalAbierta, setModalAbierta]            = useState(false);
  const [datosModal, setDatosModal]                = useState([]);
  const [prodidModal, setProdidModal]              = useState(null);
  const [carroItems, setCarroItems]                = useState([]);
  const [cantidadCarro, setCantidadCarro]          = useState('');
  const [lineas, setLineas]                        = useState([]);
  const [lineaSeleccionada, setLineaSeleccionada]  = useState('');
  const [promedioVentas, setPromedioVentas]        = useState({ promedio_ventas: 0, monto_vendido_actual: 0 });
  const [aplicaciones, setAplicaciones]            = useState({});
  const [productos2, setProductos2]                = useState([]);
  const [filtroColor, setFiltroColor]              = useState('');
  const [modalEmailAbierta, setModalEmailAbierta]  = useState(false);
  const [emailDestino, setEmailDestino]            = useState('');
  const [enviandoExcel, setEnviandoExcel]          = useState(false);

  const location  = useLocation();
  const productos = new URLSearchParams(location.search).get("productos");

  const [productosHabilitados, setProductosHabilitados] = useState([new Set]);

  useEffect(() => {
    setProductosHabilitados(new Set(productos ? productos.split(',') : []));
  }, [productos]);

  function formatearNumero(numero) {
    if (numero == null) numero = 0;
    return numero.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  useEffect(() => {
    const fetchAplicaciones = async () => {
      const nuevasAplicaciones = {};
      for (const item of productos2) {
        try {
          const res = await axios.get(`https://apigabtecbi.automarco.cl:3003/api/aplicacion-principal/${item.prod_id}`);
          nuevasAplicaciones[item.prod_id] = res.data;
        } catch (err) {
          nuevasAplicaciones[item.prod_id] = "No disponible";
        }
      }
      setAplicaciones(nuevasAplicaciones);
    };
    if (Array.isArray(productos2) && productos2.length > 0) fetchAplicaciones();
  }, [productos2]);

  const fetchPromedioVentas = async () => {
    try {
      const response = await axios.get("https://apigabtecbi.automarco.cl:3003/api/promedioVentas", {
        params: { ven: cli }
      });
      if (response.data.length > 0) setPromedioVentas(response.data[0]);
    } catch (error) {
      console.error('Error fetching promedio ventas:', error);
    }
  };

  useEffect(() => { fetchPromedioVentas(); }, []);

  const loadData = async () => {
    let buscar = document.getElementById('search').value;
    await axios.get("https://apigabtecbi.automarco.cl:3003/api/frecuentes", {
      params: { ven: cli, bus: buscar }
    }).then((response) => { setData(response.data); });
  };

  const loadModalData = async (prodid) => {
    try {
      const response = await axios.get("https://apigabtecbi.automarco.cl:3003/api/aplicaciones", {
        params: { prodid }
      });
      setDatosModal(response.data);
      setProdidModal(prodid);
    } catch (error) {
      console.error('Error al cargar datos de la modal:', error);
    }
  };

  const effectRan = useRef(false);

  useEffect(() => {
    const input = document.getElementById('search');
    if (input) input.setAttribute('autocomplete', 'off');
    if (!effectRan.current) loadData();
    return () => { effectRan.current = true; };
  }, []);

  useEffect(() => {
    let buscar = document.getElementById('search').value;
    const fetchLineas = async () => {
      try {
        const response = await axios.get("https://apigabtecbi.automarco.cl:3003/api/select-lineas-frecuentes", {
          params: { ven: cli, bus: buscar }
        });
        setLineas(response.data);
      } catch (error) {
        console.error('Error al obtener las líneas:', error);
      }
    };
    fetchLineas();
  }, []);

  async function busqueda() { await loadData(); }

  const formatoNumero = (numero) => numero.toLocaleString('es-ES');

  const abrirModal = (prodid) => { loadModalData(prodid).then(() => setModalAbierta(true)); };
  const cerrarModal = () => setModalAbierta(false);

  const handlePageChange = (page) => setCurrentPage(page);
  const handleItemsPerPageChange = (e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); };
  const obtenerProdId = (item) => item.prod_id;

  const handleCantidadChange = (prodId, e) => {
    let nuevaCantidad = e.target.value;
    const cantidadNumerica = parseInt(nuevaCantidad, 10);
    if (/^\d*$/.test(nuevaCantidad) && cantidadNumerica >= 0) {
      if (nuevaCantidad.length === 1 && nuevaCantidad === "0") nuevaCantidad = "";
      setCantidadCarro((prev) => ({ ...prev, [prodId]: nuevaCantidad }));
    }
  };

  const handleKeyDown = (e, prodId) => {
    if (e.key === 'Backspace') {
      setCantidadCarro((prev) => ({ ...prev, [prodId]: (prev[prodId] || '').slice(0, -1) }));
    }
  };

  const agregarAlCarro = async () => {
    const sucursal    = cli.slice(-1);
    const dv          = cli.slice(-2, -1);
    const rutBase     = cli.slice(0, -2);
    const rutCompleto = `${rutBase}-${dv}`;
    const itemsSeleccionados = data.map(item => {
      const prodId   = obtenerProdId(item);
      const cantidad = cantidadCarro[prodId] && cantidadCarro[prodId].trim() !== '' ? cantidadCarro[prodId] : '0';
      return { prodId, cantidad, precio: item.prod_precio };
    });
    const itemsValidos = itemsSeleccionados.filter(item => item.cantidad !== '0');
    if (itemsValidos.length > 0) {
      try {
        await fetch('https://apigabtecbi.automarco.cl:3003/api/log-movimientos', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ rutCompleto, sucursal, accion: 'bi frecuentes', items: itemsValidos })
        });
      } catch (error) { console.error("Error al guardar log:", error); }
      setCantidadCarro({});
      setCarroItems([...carroItems, ...itemsValidos]);
      if (typeof window.Android !== 'undefined') window.Android.recibirDatos(JSON.stringify(itemsValidos));
    } else {
      toast.error('Por favor, ingresa una cantidad válida.');
    }
  };

  const itemsFiltrados = data.filter((item) => {
    const pasaLinea = !lineaSeleccionada || item.cla_nombre === lineaSeleccionada;
    if (!pasaLinea) return false;
    if (!filtroColor) return true;
    return calcularColor(item.metrica3, item.metrica) === filtroColor;
  });

  const startIndex         = (currentPage - 1) * itemsPerPage;
  const endIndex           = startIndex + itemsPerPage;
  const totalFilteredPages = Math.ceil(itemsFiltrados.length / itemsPerPage);
  const itemsFiltrados2    = itemsFiltrados.slice(startIndex, endIndex);

  useEffect(() => {
    setProductos2(itemsFiltrados.slice(startIndex, endIndex));
  }, [startIndex, endIndex, lineaSeleccionada, filtroColor, data]);

  useEffect(() => { setCurrentPage(1); }, [filtroColor, lineaSeleccionada]);

  const handleEnviarExcel = async () => {
    if (!emailDestino || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailDestino)) {
      toast.error('Por favor ingresa un correo electrónico válido.');
      return;
    }
    setEnviandoExcel(true);
    try {
      const productosParaExcel = itemsFiltrados.map(item => ({
        prod_id:      item.prod_id,
        id_prov:      item.id_prov,
        prod_precio:  item.prod_precio,
        prod_stock:   item.prod_stock,
        marca_nombre: item.marca_nombre,
        cla_nombre:   item.cla_nombre,
        metrica:      item.metrica,
        metrica2:     item.metrica2,
        metrica3:     item.metrica3,
        color:        calcularColor(item.metrica3, item.metrica),
        aplicacion:   aplicaciones[item.prod_id] || '',
      }));
      const response = await fetch('https://apigabtecbi.automarco.cl:3003/api/enviar-excel-frecuentes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: emailDestino, productos: productosParaExcel, filtro: filtroColor || 'todos', ven: cli })
      });
      if (response.ok) {
        toast.success(`Excel enviado correctamente a ${emailDestino}`);
        setModalEmailAbierta(false);
        setEmailDestino('');
      } else {
        const err = await response.json();
        toast.error('Error al enviar: ' + (err.error || 'desconocido'));
      }
    } catch (error) {
      toast.error('Error de conexión al enviar el Excel.');
    } finally {
      setEnviandoExcel(false);
    }
  };

  const contarPorColor = (color) =>
    data
      .filter(item => !lineaSeleccionada || item.cla_nombre === lineaSeleccionada)
      .filter(item => calcularColor(item.metrica3, item.metrica) === color)
      .length;

  return (
    <>
      <h3 className='titulo'>Productos Frecuentes</h3>
      <div style={{ marginTop: "30px", marginLeft: "10px", marginRight: "0px" }}>

        <Table size="sm" style={{ width: '40%' }}>
          <thead>
            <tr>
              <th>Promedio Ventas (Últimos 12 meses)</th>
              <th>Monto Vendido Mes Actual</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>${formatearNumero(promedioVentas.promedio_ventas)}</td>
              <td>${formatearNumero(promedioVentas.monto_vendido_actual)}</td>
            </tr>
          </tbody>
        </Table>

        <div className='form-inline'>
          <div id="field_wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
              <div className="my-class-form-control-group">
                <Form.Control type="search" id="search" autoComplete="off" style={{ width: "300px", fontSize: "12px" }} />
              </div>
              <Button onClick={busqueda} style={{ fontSize: "12px" }}>Buscar</Button>
              <select className="form-select" style={{ width: '200px', fontSize: "12px" }} value={lineaSeleccionada}
                onChange={(e) => setLineaSeleccionada(e.target.value)}>
                <option value="">Selecciona una línea</option>
                {lineas.map((linea) => (
                  <option key={linea.cla_nombre} value={linea.cla_nombre}>{linea.cla_nombre}</option>
                ))}
              </select>

              {/* Botones de filtro semáforo */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginLeft: '8px' }}>
                {/* Todos */}
                <Button size="sm" style={{
                  fontSize: "11px",
                  backgroundColor: filtroColor === '' ? '#0d6efd' : '#e9ecef',
                  color: filtroColor === '' ? '#fff' : '#333',
                  border: '1px solid #ced4da',
                  fontWeight: filtroColor === '' ? 'bold' : 'normal',
                  minWidth: '54px',
                }} onClick={() => setFiltroColor('')}>Todos</Button>

                {/* Rojo, Amarillo, Verde */}
                {[
                  { key: 'rojo',     emoji: '🔴', label: 'Rojo' },
                  { key: 'amarillo', emoji: '🟡', label: 'Amarillo' },
                  { key: 'verde',    emoji: '🟢', label: 'Verde' },
                ].map(({ key, emoji, label }) => {
                  const count  = contarPorColor(key);
                  const activo = filtroColor === key;
                  return (
                    <Button key={key} size="sm" style={{
                      fontSize: "11px",
                      backgroundColor: activo ? COLOR_HEX[key] : '#e9ecef',
                      color: activo ? '#fff' : '#333',
                      border: `1px solid ${activo ? COLOR_HEX[key] : '#ced4da'}`,
                      fontWeight: activo ? 'bold' : 'normal',
                      minWidth: '72px',
                    }} onClick={() => setFiltroColor(activo ? '' : key)} title={`Filtrar ${label} (${count})`}>
                      {emoji} {label}{' '}
                      <span style={{ background: activo ? 'rgba(255,255,255,0.3)' : '#ccc', borderRadius: '8px', padding: '0 5px', fontSize: '10px', marginLeft: '2px' }}>{count}</span>
                    </Button>
                  );
                })}

                {/* Nuevo — sin color de semáforo, borde neutro */}
                {(() => {
                  const count  = contarPorColor('nuevo');
                  const activo = filtroColor === 'nuevo';
                  return (
                    <Button key="nuevo" size="sm" style={{
                      fontSize: "11px",
                      backgroundColor: activo ? '#6c757d' : '#e9ecef',
                      color: activo ? '#fff' : '#333',
                      border: `1px solid ${activo ? '#6c757d' : '#ced4da'}`,
                      fontWeight: activo ? 'bold' : 'normal',
                      minWidth: '72px',
                    }} onClick={() => setFiltroColor(activo ? '' : 'nuevo')} title={`Filtrar Nuevo (${count})`}>
                      Nuevo{' '}
                      <span style={{ background: activo ? 'rgba(255,255,255,0.3)' : '#ccc', borderRadius: '8px', padding: '0 5px', fontSize: '10px', marginLeft: '2px' }}>{count}</span>
                    </Button>
                  );
                })()}
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: 'auto' }}>
              <select className="form-select" style={{ width: '120px', fontSize: "12px" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
                <option value={10}>Mostrar 10</option>
                <option value={20}>Mostrar 20</option>
              </select>
              <Button variant="success" size="sm" style={{ fontSize: "12px", whiteSpace: 'nowrap' }}
                onClick={() => setModalEmailAbierta(true)} disabled={itemsFiltrados.length === 0}>
                📧 Enviar Excel
                {filtroColor && <span style={{ marginLeft: '4px', fontSize: '10px', opacity: 0.85 }}>({itemsFiltrados.length})</span>}
              </Button>
            </div>
          </div>
        </div>

        <br />

        <div className="my-class-form-control-group">
          <Table size="sm" className='titulos_tablas table-custom'>
            <thead>
              <tr>
                <th style={{ width: "6px", padding: 0 }}></th>
                <th>Frecuentes</th>
                <th>Cod. Fabrica</th>
                <th>Linea</th>
                <th>Marca</th>
                <th>Precio</th>
                <th>Stock</th>
                <th>Facturado</th>
                <th>Promedio</th>
                <th>Aplicaciones</th>
                <th>Unidades</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {itemsFiltrados2.length === 0 ? (
                <tr>
                  <td colSpan="12" style={{ textAlign: "center", padding: '12px' }}>
                    {filtroColor ? `No hay productos con semáforo ${filtroColor}` : 'No hay resultados'}
                  </td>
                </tr>
              ) : (
                itemsFiltrados2.map((item, index) => {
                  const colorKey   = calcularColor(item.metrica3, item.metrica);
                  // 'nuevo' → barra transparente (sin color)
                  const colorBarra = COLOR_HEX[colorKey] || 'transparent';
                  // Filas pares blanco, impares gris más oscuro (antes #f5f5f5, ahora #e8e8e8)
                  const rowBg = index % 2 === 0 ? '#ffffff' : '#e8e8e8';
                  const td = { ...CELL, backgroundColor: rowBg };

                  return (
                    <tr key={item.prod_id} style={{ textAlign: "left" }}>
                      <td style={{ padding: 0, width: "18px", minWidth: "6px", backgroundColor: colorBarra, borderRadius: "3px" }} />
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>{item.prod_id}</td>
                      <td style={{ ...td, whiteSpace: 'pre-line' }}>{item.id_prov}</td>
                      <td style={{ ...td }}>
                        {item.cla_nombre}
                        <br />
                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#555' }}>
                          {aplicaciones[item.prod_id] || 'Cargando...'}
                        </span>
                      </td>
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>{item.marca_nombre}</td>
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>${formatoNumero(item.prod_precio)}</td>
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>{formatoNumero(item.prod_stock)}</td>
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>{item.metrica}</td>
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>{item.metrica2}</td>
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>
                        <Button onClick={() => abrirModal(item.prod_id)} style={{ fontSize: "12px" }}>Aplic</Button>
                      </td>
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>
                        {item.multiplo && item.multiplo > 1 ? (
                          <InputGroup>
                            <InputGroup.Text id="basic-addon2">
                              <select
                                value={cantidadCarro[item.prod_id] || ''}
                                onChange={(e) => handleCantidadChange(item.prod_id, e)}
                              >
                                {[...Array(Math.floor(100 / item.multiplo))].map((_, i) => (
                                  <option key={i + 1}>{item.multiplo * (i + 1)}</option>
                                ))}
                              </select>
                            </InputGroup.Text>
                          </InputGroup>
                        ) : (
                          <FormControl
                            type="text"
                            value={cantidadCarro[item.prod_id] || ''}
                            onChange={(e) => handleCantidadChange(item.prod_id, e)}
                            onKeyDown={(e) => handleKeyDown(e, item.prod_id)}
                            style={{ width: "60px" }}
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                        )}
                      </td>
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>
                        {productosHabilitados.has(item.prod_id) && (
                          <img src={carrito} alt="Carrito" width="25" />
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>

          {/* Modal Aplicaciones */}
          <Modal show={modalAbierta} onHide={cerrarModal}>
            <Modal.Header closeButton>
              <Modal.Title>{`Aplicaciones - Producto ${prodidModal || ''}`}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Table size="sm">
                <thead>
                  <tr>
                    <th>Marca</th><th>Modelo</th><th>Cilindrada</th>
                    <th>Posición</th><th>Año Inicio</th><th>Año Término</th>
                  </tr>
                </thead>
                <tbody>
                  {datosModal.map((item) => (
                    <tr style={{ textAlign: "left" }} key={item.pm_id}>
                      <td style={{ borderBottomWidth: "0px", width: "12%" }}>{item.marca_nombre}</td>
                      <td style={{ borderBottomWidth: "0px", width: "12%" }}>{item.mod_id}</td>
                      <td style={{ borderBottomWidth: "0px", width: "12%" }}>{item.cilindrada}</td>
                      <td style={{ borderBottomWidth: "0px", width: "12%" }}>{item.ubi_nombre}</td>
                      <td style={{ borderBottomWidth: "0px", width: "12%" }}>{item.inicio}</td>
                      <td style={{ borderBottomWidth: "0px", width: "12%" }}>{item.fin}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={cerrarModal}>Cerrar</Button>
            </Modal.Footer>
          </Modal>

          {/* Modal Enviar Excel */}
          <Modal show={modalEmailAbierta} onHide={() => { setModalEmailAbierta(false); setEmailDestino(''); }}>
            <Modal.Header closeButton>
              <Modal.Title>📧 Enviar Excel por correo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p style={{ fontSize: '14px', marginBottom: '12px' }}>
                Se generará un Excel con <strong>{itemsFiltrados.length} producto{itemsFiltrados.length !== 1 ? 's' : ''}</strong>
                {filtroColor && <span> (filtro: <span style={{ color: COLOR_HEX[filtroColor] || '#6c757d', fontWeight: 'bold' }}>{filtroColor}</span>)</span>}
                {' '}y se enviará al correo ingresado.
              </p>
              <Form.Group>
                <Form.Label style={{ fontSize: '13px' }}>Correo electrónico de destino</Form.Label>
                <Form.Control type="email" placeholder="ejemplo@correo.com" value={emailDestino}
                  onChange={(e) => setEmailDestino(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') handleEnviarExcel(); }}
                  autoFocus style={{ fontSize: '13px' }} />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => { setModalEmailAbierta(false); setEmailDestino(''); }} disabled={enviandoExcel}>
                Cancelar
              </Button>
              <Button variant="success" onClick={handleEnviarExcel} disabled={enviandoExcel || !emailDestino}>
                {enviandoExcel ? 'Enviando...' : 'Enviar Excel'}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>

        <Pagination>
          <Pagination.Prev disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)} />
          {Array.from({ length: totalFilteredPages }, (_, index) => (
            <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => handlePageChange(index + 1)}>
              {index + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next disabled={currentPage === totalFilteredPages} onClick={() => handlePageChange(currentPage + 1)} />
        </Pagination>

        <Button variant="primary" onClick={agregarAlCarro} style={{ float: 'right', marginRight: '180px', fontSize: "12px" }}>
          Agregar al Carro
        </Button>
      </div>
    </>
  );
};

export default TabContent;